// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sandile: PokeData = {
  "id": 551,
  "name": "sandile",
  "height": 7,
  "weight": 152,
  "base_experience": 58,
  "types": [
    PokeType.GROUND,
    PokeType.DARK
  ],
  "api_moves": [
    "sand-attack",
    "thrash",
    "leer",
    "bite",
    "earthquake",
    "dig",
    "rage",
    "scary-face",
    "mud-slap",
    "sandstorm",
    "swagger",
    "crunch",
    "torment",
    "sand-tomb",
    "assurance",
    "embargo",
    "hone-claws",
    "foul-play",
    "power-trip"
  ],
  "moves": [
    "leer",
    "bite",
    "earthquake",
    "scary-face",
    "mud-slap",
    "sandstorm",
    "crunch",
    "quash",
    "fissure",
    "snatch",
    "rototiller",
    "phantom-force",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 281,
    "item": null,
    "species": [
      {
        "name": "sandile",
        "order": 552,
        "types": [
          PokeType.GROUND,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "krokorok",
        "order": 553,
        "types": [
          PokeType.GROUND,
          PokeType.DARK
        ],
        "evolves_from_species_id": 551,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 29,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "krookodile",
        "order": 554,
        "types": [
          PokeType.GROUND,
          PokeType.DARK
        ],
        "evolves_from_species_id": 552,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 65,
    "ability_power": 72
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
